import React from "react";
/* The authoritative display prices — the same module the checkout uses, so
   this card cannot advertise a rate the purchase screen disagrees with. */
import {
  WEB_PROFILE_STANDARD,
  WEB_PROFILE_MEMBER,
  MEMBER_DISCOUNT_RATE,
} from "../../../../constants/webProfilePricing";
import { Link } from "react-router-dom";
import { MemberPill } from "../../u1/MemberPill";
import { Dirham, ArrowRight } from "../../../../assets/ui/icons";

/* Right-rail card 2 — the researcher path. */
export const ResearcherCard = ({ orderWebProfileState }) => (
  <section
    className="rounded-[14px] border border-[var(--line)] bg-white p-6"
    aria-labelledby="u1-researcher-heading"
  >
    <p className="text-[10.5px] font-bold tracking-[.1em] uppercase text-[var(--muted)] font-sans m-0 mb-2">
      For researchers
    </p>
    <h2
      id="u1-researcher-heading"
      className="text-[18px] font-bold leading-[1.3] text-[var(--ink)] font-sans m-0"
    >
      Looking for a business that isn&apos;t here?
    </h2>
    <p className="text-[13px] leading-[1.55] text-[var(--muted)] font-sans mt-2 m-0">
      Order a Web Profile on any business you are researching, inside or outside the UAE. TREVEX
      builds it from licensing data and public filings, and delivers it to your dashboard within 24
      hours.
    </p>

    {/* Two-tier pricing — standard vs. Member rate. */}
    <div className="mt-4 rounded-xl border border-[var(--line)] overflow-hidden">
      <div className="flex items-center justify-between px-3.5 py-[11px] bg-[var(--slate-2)]">
        <span className="text-[13px] font-semibold text-[var(--ink-2)] font-sans">Standard</span>
        <span className="text-[17px] font-bold text-[var(--ink)] font-sans">
          <Dirham />
          {WEB_PROFILE_STANDARD}
        </span>
      </div>
      <div className="flex items-center justify-between px-3.5 py-[11px] border-t border-[var(--line)]">
        <span className="inline-flex items-center gap-[7px]">
          <MemberPill />
          <span className="text-[13px] font-semibold text-[var(--success)] font-sans">
            save {MEMBER_DISCOUNT_RATE * 100}%
          </span>
        </span>
        <span className="text-[15px] font-bold text-[var(--gold-deep)] font-sans">
          <Dirham />
          {WEB_PROFILE_MEMBER.toFixed(2)}
        </span>
      </div>
    </div>

    <p className="text-[13px] leading-[1.5] text-[var(--muted)] font-sans mt-3 m-0">
      <Link to="/membership" className="text-[var(--orange)] font-semibold hover:underline">
        Become a Member
      </Link>{" "}
      to get the rate, plus the Partner Program and Payment Endorsements.
    </p>

    {/* The design's .btn-order: full width, 50px tall, 12px radius, with a coral glow beneath. */}
    <Link
      to="/order-web-profile"
      state={orderWebProfileState}
      className="mt-3.5 flex h-[50px] w-full items-center justify-center gap-[9px] rounded-xl bg-[var(--coral)] text-[15px] font-bold text-white shadow-[shadow:var(--coral-glow)] transition-colors duration-150 hover:bg-[var(--orange-hover)]"
    >
      Order a Web Profile <ArrowRight />
    </Link>
  </section>
);

export default ResearcherCard;
